// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import '@modulaire/shared/js/wwdev/forms/index';
import '@fancyapps/fancybox';
import '@modulaire/shared/js/wwdev/lazysizes/index.js';
import '@modulaire/shared/js/wwdev/webshop/index.js';
import '@wwdev/register';
import '@wwdev/search';
import '@wwdev/functions/setEqualHeightsPerRow';
import '@modulaire/shared/js/externals/hamburgers.js';
import '@modulaire/shared/js/externals/flickity/index.js';

// Base
import '@modulaire/shared/js/base/header';